var a;!function(a){a[a.ExtraSmall=16]="ExtraSmall",a[a.Small=24]="Small",a[a.Medium=32]="Medium",a[a.Large=48]="Large",a[a.ExtraLarge=72]="ExtraLarge"}(a||(a={}));export{a as EIconSizes};
//# sourceMappingURL=constants.js.map
